import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import { toast } from "react-toastify";
import style from "../common.module.scss";
import { File } from "../../../../services";
import EyeIcon from "../../../shared/icons/EyeIcon";
import Loading from "../../../shared/Loading/Loading";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import DocumentNewIcon from "../../../shared/icons/DocumentNewIcon";
import PhotoViewer from "../../../partners/components/PhotoViewer";
import moment from "moment";
import UnloadIcon from "../../../shared/icons/UnloadIcon";
import {t} from "i18next";

const getDocumentTypeName = (documentType) => {
  const typeMap = {
    1: t("documentStatuses.cargoPhoto"),
    2: t("documentStatuses.loadingSeal"),
    3: t("documentStatuses.unloadingSeal"),
    4: t("documentStatuses.ttn"),
  };
  return typeMap[documentType] || "Документ";
};

const ListDocsOrder = ({ setShowModal, documents }) => {
  const [loadingStates, setLoadingStates] = useState({});
  const [loadingStatesDownload, setLoadingStatesDownload] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [imgUrl, setImgUrl] = useState();
  const [currentDocType, setCurrentDocType] = useState("");
  const [cachedFiles, setCachedFiles] = useState({});

  const modalRef = useRef(null);

  useClickOutside(modalRef, () => {
    setShowModal(false);
  });

  const handleClose = () => {
    setIsOpen(false);
  };

  const setLoadingViewer = (docId, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [docId]: isLoading }));
  };

  const setLoadingDownload = (docId, isLoading) => {
    setLoadingStatesDownload((prev) => ({ ...prev, [docId]: isLoading }));
  };

  const handleOpenPhoto = (docType, addressId) => {
    const doc = documents.find(
      (x) => x.documentType === docType && x.addressId === addressId
    );
  
    if (!doc) {
      alert("Фото не найден");
      return;
    }

    if (cachedFiles[doc.fileId]) {
      setImgUrl(cachedFiles[doc.fileId]);
      setCurrentDocType(docType);
      setIsOpen(true);
      return;
    }

    setLoadingViewer(doc.fileId, true);
    File.downloadFileById(doc.fileId)
      .then((response) => {
        const file = new Blob([response.data], {
          type: response.data.type,
        });

        const fileURL = URL.createObjectURL(file);
        setImgUrl(fileURL);
        setCurrentDocType(docType);
        setIsOpen(true);
        setLoadingViewer(doc.fileId, false);

        setCachedFiles((prev) => ({
          ...prev,
          [doc.fileId]: fileURL,
        }));
      })
      .catch((error) => {
        setLoadingViewer(doc.fileId, false);
        console.log(error);
      });
  };

  const onDownload = (docType, addressId) => {
    const docx = documents.find(
      (x) => x.documentType === docType && x.addressId === addressId
    );
    if (!docx) {
      alert("Фото не найден");
      return;
    }
    setLoadingDownload(docx.fileId, true); 

    if (cachedFiles[docx.fileId]) {
      const a = document.createElement("a");
      a.href = cachedFiles[docx.fileId];
      a.setAttribute("download", "image.jpg");
      a.click();
      setLoadingDownload(docx.fileId, false);
      return;
    }

    File.downloadFileById(docx.fileId)
      .then((response) => {
        const file = new Blob([response.data], {
          type: response.data.type,
        });

        const fileURL = URL.createObjectURL(file);
        const a = document.createElement("a");
        a.href = fileURL;
        a.setAttribute("download", "image.jpg");
        a.click();

        setCachedFiles((prev) => ({
          ...prev,
          [docx.fileId]: fileURL,
        }));
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoadingDownload(docx.fileId, false);
      });
  };

  return (
    <>
      <div className={style.cargo_wrapper}>
        {documents && documents.length > 0 ? (
          <div className={style.documentsList}>
            {documents.map((doc, index) => (
              <div key={index} className={style.documentItem}>
                <div className={style.documentItem_icon}>
                  <DocumentNewIcon />
                </div>
                <div className={style.documentItem_content}>
                  <div className={style.documentItem_name}>
                    {getDocumentTypeName(doc.documentType)}
                  </div>
                  <div className={style.documentItem_size}>
                    {moment(doc?.createdAt).format("DD.MM.YYYY")} - {" "}
                    {moment(doc?.createdAt).format("HH:mm")}
                  </div>
                </div>

                {loadingStatesDownload[doc?.fileId] ? (
                  <Loading inBlock marginBottom={0} />
                ) : (
                  <UnloadIcon
                    onClick={() => {
                      onDownload(doc.documentType, doc.addressId);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                )}

                {loadingStates[doc?.fileId] ? (
                  <Loading inBlock marginBottom={0} />
                ) : (
                  <EyeIcon
                    onClick={() => {
                      handleOpenPhoto(doc.documentType, doc.addressId);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            ))}
          </div>
        ) : null}
      </div>

      {isOpen && (
        <PhotoViewer
          imgUrl={imgUrl}
          onClose={handleClose}
          onDownload={() => onDownload(currentDocType)}
          ShowBtnDownload
        />
      )}
    </>
  );
};

export default ListDocsOrder;
